<template>
  <main class="app-main">
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">إضافة طلب معاينة</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/reservations">طلبات المعاينة</router-link></li>
              <li class="breadcrumb-item active">إضافة طلب</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="app-content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <div class="card card-secondary card-outline mb-4 mt-4">
              <div class="card-header"><div class="card-title">إضافة طلب معاينة</div></div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <successAlert v-if="hasSuccess" :message="message" />

              <form @submit.prevent="submitData()">
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">جوال العميل: <span class="req">*</span></label>
                      <input type="text" class="form-control" placeholder="جوال العميل المسجل" @keyup="getClientData()" v-model="userMobile">
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <loader v-if="userLoader" />
                      <div v-if="userName">
                        <label class="form-label">اسم العميل:</label>
                        <div class="fw-bold">{{ userName }}</div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">العقار: <span class="req">*</span></label>
                      <input type="text" class="form-control" placeholder="ابحث برقم أو اسم العقار" v-model="propertySearch" @keyup="searchProperty()">
                      <div v-if="propertiesList.length" class="list-group mt-1 shadow-sm" style="max-height:180px;overflow-y:auto;position:absolute;z-index:999;width:calc(100% - 24px)">
                        <button v-for="p in propertiesList" :key="p.id" type="button"
                          class="list-group-item list-group-item-action text-start"
                          @click="selectProperty(p)">
                          #{{ p.id }} - {{ p.title }}
                        </button>
                      </div>
                      <div v-if="selectedProperty" class="mt-2">
                        <span class="badge bg-success">#{{ selectedProperty.id }} - {{ selectedProperty.title }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">تاريخ المعاينة: <span class="req">*</span></label>
                      <input type="date" class="form-control" v-model="date">
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">وقت المعاينة: <span class="req">*</span></label>
                      <input type="time" class="form-control" v-model="time">
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 mb-3">
                      <label class="form-label">العنوان / تفاصيل الموقع:</label>
                      <input type="text" class="form-control" v-model="address" placeholder="تفاصيل الموقع أو الاتجاهات...">
                    </div>
                  </div>
                </div>

                <div class="card-footer">
                  <div class="row">
                    <div class="col text-end">
                      <button v-if="!formLoader" type="submit" class="btn btn-success">إضافة</button>
                      <loader v-if="formLoader" />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { toast } from '@/helpers/tools';

export default {
  name: 'ReservationsCreate',
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSuccess: false,
      message: '',
      errorNumber: 0,

      userMobile: null,
      userId: null,
      userName: null,
      userLoader: false,

      date: null,
      time: null,
      address: null,

      propertySearch: '',
      propertiesList: [],
      selectedProperty: null,
      propertyId: null,

      searchTimer: null,
    }
  },
  methods: {
    getClientData(){
      if(this.userMobile && this.userMobile.length >= 10){
        this.hasError = false;
        this.userLoader = true;
        this.userId = null;
        this.userName = null;
        this.$http.post('/api/admin/properties/getUser', {
          mobile: this.userMobile.trim(),
        }).then(({data}) => {
          this.userId = data.user.id;
          this.userName = data.user.name;
          this.userLoader = false;
        }).catch(err => {
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
          this.userLoader = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    },
    searchProperty(){
      clearTimeout(this.searchTimer);
      if(!this.propertySearch || this.propertySearch.length < 2){
        this.propertiesList = [];
        return;
      }
      this.searchTimer = setTimeout(() => {
        this.$http.get(`/api/admin/properties/list?name=${encodeURIComponent(this.propertySearch)}&limit=10`).then(({data}) => {
          this.propertiesList = data.properties ?? [];
        });
      }, 400);
    },
    selectProperty(p){
      this.selectedProperty = p;
      this.propertyId = p.id;
      this.propertySearch = '';
      this.propertiesList = [];
    },
    submitData(){
      this.hasError = false;
      this.hasSuccess = false;

      if(!this.userId){
        this.message = 'يجب تحديد العميل عن طريق رقم الجوال أولاً';
        this.errorNumber = 0;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      if(!this.propertyId){
        this.message = 'يجب اختيار العقار المراد معاينته';
        this.errorNumber = 0;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      if(!this.date || !this.time){
        this.message = 'يرجى تحديد تاريخ ووقت المعاينة';
        this.errorNumber = 0;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      this.formLoader = true;
      this.$http.post('/api/admin/reservations/create', {
        userId: this.userId,
        propertyId: this.propertyId,
        date: this.date,
        time: this.time,
        address: this.address,
      }).then(({data}) => {
        toast('تم إضافة طلب المعاينة بنجاح', 'success');
        this.$router.push(`/reservations/update/${data.row.id}`).catch(() => {});
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
  },
}
</script>